'use client'

import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  SimpleGrid
} from '@chakra-ui/react'
import { Tabs } from "@chakra-ui/react"
//components
import { LastNewsSideBar } from 'components/noticias/LastNewsSideBar'
//icons
import { User, ClipboardList, MapPin } from "lucide-react";
//styles
import { institucionalStyles } from 'styles/institucionalStyles';
import { diretoriaStyles } from 'styles/institucionalStyles';
// Import data from separate file
import { diretoriaMembers, conselhoFiscalMembers, coordenadoresRegionais } from 'data/siteData'

type MemberCardProps = { name: string; role?: string };

const MemberCard = ({ name, role }: MemberCardProps) => (
  <Box {...diretoriaStyles.memberCard}>
    <Text {...diretoriaStyles.memberName}>{name}</Text>
    <Text {...diretoriaStyles.memberRole}>{role}</Text>
  </Box>
);

type Member = { nome: string; cargo?: string };

const TabContent = ({ members, defaultRole }: { members: Member[]; defaultRole?: string }) => (
  <SimpleGrid {...diretoriaStyles.grid}>
    {members.map((member, index) => (
      <MemberCard
        key={index}
        name={member.nome}
        role={member.cargo || defaultRole}
      />
    ))}
  </SimpleGrid>
);

export default function DiretoriaPage() {
  return (
    <Box {...diretoriaStyles.container}>
      <LastNewsSideBar />
      <Flex {...diretoriaStyles.mainFlex}>
        <Box flex="1">
          <Heading as="h1" size="2xl" {...institucionalStyles.heading} textAlign="start">
            Diretoria e Conselho
          </Heading>
          <Text {...institucionalStyles.subheading} textAlign="start">
            Conheça nossa diretoria e conselho
          </Text>

          <Box {...diretoriaStyles.tabsWrapper}>
            <Flex {...diretoriaStyles.tabsContainer}>
              <Tabs.Root {...diretoriaStyles.tabsRoot} defaultValue="diretoria" variant= "enclosed">
                <Tabs.List {...diretoriaStyles.tabsList}>
                  <Tabs.Trigger value="diretoria" {...diretoriaStyles.tabTrigger}>
                    <Flex align="center">
                      <Box {...diretoriaStyles.tabIcon}>
                        <User aria-hidden="true" />
                      </Box>
                      <span>Diretoria</span>
                    </Flex>
                  </Tabs.Trigger>

                  <Tabs.Trigger value="conselho" {...diretoriaStyles.tabTrigger}>
                    <Flex align="center">
                      <Box {...diretoriaStyles.tabIcon}>
                        <ClipboardList aria-hidden="true" />
                      </Box>
                      <span>Conselho Fiscal</span>
                    </Flex>
                  </Tabs.Trigger>

                  <Tabs.Trigger value="coordenadores" {...diretoriaStyles.tabTrigger}>
                    <Flex align="center">
                      <Box {...diretoriaStyles.tabIcon}>
                        <MapPin  aria-hidden="true" />
                      </Box>
                      <span>Coordenadores Regionais</span>
                    </Flex>
                  </Tabs.Trigger>
                </Tabs.List>

                <Tabs.Content value="diretoria" {...diretoriaStyles.tabContent}>
                  <TabContent members={diretoriaMembers} />
                </Tabs.Content>

                <Tabs.Content value="conselho" {...diretoriaStyles.tabContent}>
                  <TabContent
                    members={conselhoFiscalMembers}
                    defaultRole="Membro do Conselho Fiscal"
                  />
                </Tabs.Content>

                <Tabs.Content value="coordenadores" {...diretoriaStyles.tabContent}>
                  <TabContent members={coordenadoresRegionais} />
                </Tabs.Content>
              </Tabs.Root>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}